import { ColorPaletteType, ThemeColorsType, ThemeTailwindType } from 'src/domains/common/themeColors';

export const betStGeorgeColors: ThemeTailwindType = {
    '--primary': '323 83% 59%',
    '--menu-primary': '0 0% 100%',
    '--menu-secondary': '0 0% 100%',
};

const colorPalette: ColorPaletteType = {
    primary: '#3F4041',
    secondary: '#FF1A1A',
    tertiary: '#B3FFF0',
    dark: '#333435',
    shade1: '#3F4041',
    shade2: '#555556',
    shade3: '#6A6B6B',
    shade4: '#7F8080',
    shade5: '#CBD2D8',
    shade6: '#EAF2FC',
    textDark: '#000000',
    white: '#ffffff',
};

export const themeColors: ThemeColorsType = {
    header: {
        bgColor: colorPalette.shade1,
        bgColorSecondary: colorPalette.primary,
        bgColorTertiary: colorPalette.secondary,
        bgColorQuaternary: colorPalette.secondary,

        borderColor: colorPalette.white,
        borderColorSecondary: colorPalette.secondary,

        txtColor: colorPalette.white,
        txtColorSecondary: colorPalette.white,
        txtColorTertiary: colorPalette.white,
        txtColorQuaternary: colorPalette.white,
    },
    buttons: {
        bgColor: colorPalette.secondary,
        txtColor: colorPalette.white,
    },
    input: {
        bgColor: colorPalette.shade6,
    },
    colorPicker: {
        colors: colorPalette,
        bgDefault: colorPalette.shade1,
        txtDefault: colorPalette.white,
    },
    anniversaryModal: {
        bgColor: '',
        bgColorSecondary: '',
        bgColorTertiary: '',
        txtColor: '',
        txtColorSecondary: '',
        txtColorTertiary: '',
    },
    loginPage: {
        bgColor: colorPalette.secondary,
    },
    traderChat: {
        bgColor: colorPalette.white,
        borderColor: '#d6e6f2',
        borderColorSecondary: '#ccc',
        txtColor: '#888',
    },
    compliancePopup: {
        bgColor: '#333435',
        txtColor: '#ffffff',
        bodyTxtColor: 'rgba(255, 255, 255, 0.8)',
        buttonBgColor: '#FF1A1A',
        buttonTxtColor: '#ffffff',
        secondaryBtnBgColor: 'rgba(255, 255, 255, 0.10)',
    },
};
